import { createContext, FC, ReactNode, useContext, useState } from 'react'

type HearingIdentificationBlockFieldsContextProps = {
  isBlockedFields: boolean
  handleUnblockAllFields: () => void
}

export const HearingIdentificationBlockFieldsContext =
  createContext<HearingIdentificationBlockFieldsContextProps>({
    isBlockedFields: true,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    handleUnblockAllFields: () => {},
  } as HearingIdentificationBlockFieldsContextProps)

export const HearingIdentificationBlockFieldsProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isBlockedFields, setBlockedFields] = useState<boolean>(true)

  const unblockAllFields = () => {
    setBlockedFields(false)
  }

  return (
    <HearingIdentificationBlockFieldsContext.Provider
      value={
        {
          isBlockedFields: isBlockedFields,
          handleUnblockAllFields: unblockAllFields,
        } as HearingIdentificationBlockFieldsContextProps
      }
    >
      {children}
    </HearingIdentificationBlockFieldsContext.Provider>
  )
}

export const useHearingIdentificationBlockFieldsContext = () => {
  const { isBlockedFields, handleUnblockAllFields } = useContext(
    HearingIdentificationBlockFieldsContext,
  )

  return { isBlockedFields, handleUnblockAllFields }
}
